<template>
    <div class="container">
      <div class="element-box">
        <form autocomplete="off" @submit.prevent="salvar()">
      <div class="form-row">
        <div class="col form-group">
          <label for="name">Nome</label>
          <input required class="form-control" type="text" name="name" id="name" v-model="profissional.nome">
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label for="tipoRegistro">Conselho Profissional</label>
          <select required v-model="profissional.tipo_registro" name="tipoRegistro" id="tipoRegistro" class="form-control">
            <option value="">Selecione</option>
            <option v-for="conselho in listaConselhoProfissional" :value="conselho" :key="conselho" v-text="conselho"></option>
          </select>
        </div>
        <div class="col form-group">
          <label for="name">Número</label>
          <input required class="form-control" type="text" name="name" id="name" v-model="profissional.nr_registro">
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label for="especialidade">Especialidade</label>
            <v-select v-model="profissional.especialidade" label="name" 
              :filterable="false" :options="especialidades" @search="onSearchEspecialidade">
              <template slot="no-options">
                Digite para Filtrar a Especialidade do prestador..
              </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.name }}
                  </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.name }}
                </div>
              </template>
            </v-select>
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label >Email</label>
          <input required type="email" name="email" id="email" class="form-control" v-model="profissional.email">
        </div>
      </div>
      <div class="form-row">
        <div class="col col-md-6 form-group">
          <label>Usuário</label>
          <input required type="text" name="usr" id="usr" v-model="profissional.username" class="form-control">
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
            <label for="password">Senha</label>
            <input required type="password" v-model="profissional.password" name="password" id="password" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
        </div>
        <div class="col form-group">
            <label for="testPassword">Repetir Senha</label>
            <input required type="password" v-model="profissional.password" name="testPassword" id="testPassword" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
        </div>
      </div>
      <div class="form-row">
        <div class="col form-group">
          <label for="miniBio">Currículo</label>
          <textarea v-model="profissional.mini_bio" class="form-control" name="miniBio" id="miniBio" cols="30" rows="10"></textarea>
        </div>
      </div>
      <div class="col text-center">
        <button type="submit" class="btn btn-primary">Salvar</button>
      </div>
    </form>
      </div>
    </div>
</template>
<script>
import _ from 'lodash'

export default {
  created () {
    if (this.$store.getters.user.corpoClinico) {
      this.$store.dispatch('loadCorpoClinico', this.$store.getters.user.corpoClinico)
        .then((corpoClinico) => { this.profissional = corpoClinico })
    }
  },
  data () {
    return {
      especialidades: [],
      listaConselhoProfissional: [
        'CRM', 'CRF', 'COREN', 'CREFITO', 'CREFONO', 'CRMV', 'CRN', 'CRO', 'CRP', 'CRTR'
      ],
      profissional: {
        nome: null,
        tipo_registro: '',
        nr_registro: null
      }
    }
  },
  methods: {
    onSearchEspecialidade (search, loading) {
      loading(true)
      this.searchEspecialidade(loading, search, this)
    },
    searchEspecialidade: _.debounce((loading, search, vm) => {
      vm.$store.dispatch('getEspecialidade', search).then(especialidades => {
        loading(false)
        vm.especialidades = especialidades
      })
    }, 350),
    salvar () {
      this.profissional.rede = this.$store.getters.rede
      this.$store.dispatch('saveCorpoClinico', this.profissional)
        .then(() => {
          this.$store.dispatch('setProfissional')
          this.$router.push({name: 'HomeAdmin'})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/DadosProfissionalAutenticado.vue